import styled from 'styled-components'

const Wrapper = styled.div`
  margin-bottom: 0.625rem;
`

const Header = styled.p`
  display: block;
  max-width: 100%;
  margin-bottom: 0;
  text-transform: capitalize;
`
const OpenModalText = styled.div`
  cursor: pointer;
  font-weight: bold;
  text-decoration: underline;
`
const ModalSwatchContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  &::after {
    content: '';
    height: 1px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 1rem;
    margin-bottom: 1rem;
    background-color: grey;
    opacity: 0.4;
  }
`

const ModalSwatchFooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
`

export { Wrapper, Header, OpenModalText, ModalSwatchContainer, ModalSwatchFooterContainer }
